import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	card: {
		padding: "20px",
		border: `1px solid ${themeColors.colors.system.gray[200]}`,
		borderRadius: "12px",
		backgroundColor: themeColors.colors.base.white,
		height: "100%"
	},
	cardTitle: {
		fontSize: "1rem",
		fontWeight: 600,
		color: themeColors.colors.system.gray[900]
	},
	cardSubtitle: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[500]
	},
	metaLabel: {
		color: themeColors.colors.system.gray[700],
		fontWeight: 500,
		fontSize: "0.875rem"
	},
	scoreGeneralNumber: {
		fontSize: "5rem",
		fontWeight: 700,
		color: themeColors.colors.system.gray[900]
	},
	topicLabel: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[900],
		fontWeight: 700
	},
	quoteBox: {
		padding: "12px",
		backgroundColor: themeColors.colors.system.gray[50],
		borderRadius: "8px",
		color: themeColors.colors.system.gray[500],
		fontSize: "0.875rem",
		fontStyle: "italic"
	},
	quoteIcon: {
		color: themeColors.colors.system.gray[400],
		marginRight: 4
	},
	loadingContainer: {
		padding: "64px",
		textAlign: "center"
	}
}))

export default useStyles
